import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Global fetch interceptor to support multi-domain query routing dynamically
const originalFetch = window.fetch;
window.fetch = async (url, options = {}) => {
  const domainId = localStorage.getItem("selected_domain_id") || "1"; // Default: 1 (map)
  const qdrantCollection = localStorage.getItem("selected_qdrant_collection") || "map";
  
  if (typeof url === 'string' && (url.startsWith('/') || url.includes('/api/') || url.includes('ximilar'))) {
    const headers = options.headers instanceof Headers 
      ? new Headers(options.headers) 
      : { ...options.headers };
      
    if (headers instanceof Headers) {
      headers.set('x-domain-id', domainId);
      headers.set('x-qdrant-collection', qdrantCollection);
    } else {
      headers['x-domain-id'] = domainId;
      headers['x-qdrant-collection'] = qdrantCollection;
    }
    options.headers = headers;
    console.log("Options:", options)
  }
  return originalFetch(url, options);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
